// Versión y datos de marca de la plataforma Eneural.
// Cambia APP_VERSION aquí para actualizar el pie de página en todo el portal.
export const APP_VERSION = 'v2.0';
export const COPYRIGHT_YEAR = 2026;

export function AppFooter() {
  return (
    <footer
      style={{
        flex: '0 0 auto',
        textAlign: 'center',
        padding: '8px 16px',
        fontSize: 12,
        color: '#64748b',
        background: '#0b1120',
        borderTop: '1px solid #1e293b',
      }}
    >
      Powered by Netvoice · Eneural {APP_VERSION} · Copyright © {COPYRIGHT_YEAR}
    </footer>
  );
}
